import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { useNavigate } from 'react-router-dom'

import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'
import FeaturedTable from '../../FeaturedTable/FeaturedTable'
import { columns, sortOptions } from '../helpers'
import { getGroups, selectGroups } from '../../../reducers/Organisation/groupsReducer'

import GroupSettingsToolbar from './GroupSettingsToolbar/GroupSettingsToolbar'

const GroupsSettings = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isLoading, setLoading] = useState(false)
  const [selectedBuilding, setSelectedBuilding] = useState(null)

  const [search, setSearch] = useState('')
  const [prevSearchValue, setPrevSearchValue] = useState('')
  const [sortOrder, setSortOrder] = useState(sortOptions[0])

  const groups = useSelector(selectGroups)
  const building = useSelector(selectActiveBuilding)

  const handleEdit = (groupId) => {
    navigate(`/dashboard/building-dashboard/groups-settings/edit/${groupId}`)
  }

  useEffect(() => {
    if (building && selectedBuilding !== building.id) {
      setLoading(true)
      fetchGroups()
      setSelectedBuilding(building.id)
    }
  }, [building])

  const fetchGroups = async (query) => {
    try {
      if (!building) return

      if (query === undefined) {
        query = search
      }

      await dispatch(getGroups(building.id, query, sortOrder.value))
    } catch ({ message }) {
      console.error(message)
    } finally {
      setLoading(false)
    }
  }

  const debounceFn = debounce(fetchGroups, 1000)

  useEffect(() => {
    if (prevSearchValue !== search) {
      window.addEventListener('keydown', debounceFn(search))
    }
    setPrevSearchValue(search)
    return () => {
      window.removeEventListener('keydown', debounceFn)
    }
  }, [search])

  useEffect(() => {
    if (sortOrder.value) {
      fetchGroups()
    }
  }, [sortOrder])

  return (
    <>
      <GroupSettingsToolbar
        search={search}
        setSearch={setSearch}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
      />
      <div className={`groups-settings ${isLoading ? 'is-loading' : ''}`}>
        <div className="groups-settings-table-container">
          {groups.length > 0 ? (
            <div className="groups-settings-table">
              <FeaturedTable
                columns={columns({ handleEdit })}
                data={groups}
                onRowClick={() => {}}
              />
            </div>
          ) : (
            <div className="error-message">No available groups</div>
          )}
        </div>
      </div>
    </>
  )
}

GroupsSettings.propTypes = {
  groups: PropTypes.array,
  getGroups: PropTypes.func,
  params: PropTypes.object,
  building: PropTypes.object,
  router: PropTypes.object,
}

export default GroupsSettings
